import React from 'react';

export type RatingTag = 'S' | 'D';

interface RatingChipProps {
  tag: RatingTag;
  value: number | null | undefined;
  prominent?: boolean;
  pair?: boolean;
}

export function RatingChip({ tag, value, prominent, pair }: RatingChipProps): JSX.Element {
  const present = value != null;
  const discipline = tag === 'D' ? 'debla' : 'singla';
  const presentTitle = pair ? `Średni ranking ${discipline} pary` : `Ranking ${discipline}`;
  const className = `pac-chip pac-chip--${tag.toLowerCase()}${prominent ? ' pac-chip--prominent' : ''}${present ? '' : ' pac-chip--empty'}`;

  return (
    <span
      className={className}
      title={present ? presentTitle : `Brak rankingu ${discipline}`}
    >
      <span className="pac-chip__tag">{tag}</span>
      <span className="pac-chip__value">{present ? value : '—'}</span>
    </span>
  );
}
